import { ChangeDetectionStrategy, Component, OnDestroy, inject } from '@angular/core';
import { Router, RouterLink } from '@angular/router';

import { MatDialog } from '@angular/material/dialog';

import { FsSidenavModule, MENU_DATA, SidenavMenuRef } from '@firestitch/sidenav';

import { Subject } from 'rxjs';

import { AclService } from '@app/core';
import { AccountData } from '@common/data';

import { CreateComponent } from '@app/environment/modules/create/components/create';


import { EnvironmentSwitchComponent } from '../environment-switch/environment-switch.component';


@Component({
    templateUrl: './environment-menu.component.html',
    styleUrls: ['./environment-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    FsSidenavModule,
    RouterLink
],
})
export class EnvironmentMenuComponent implements OnDestroy {
  data = inject(MENU_DATA);
  dialog = inject(MatDialog);
  router = inject(Router);
  accountData = inject(AccountData);
  private _aclService = inject(AclService);
  menuRef = inject<SidenavMenuRef<EnvironmentMenuComponent>>(SidenavMenuRef);


  public environment;
  public hasSettingsAccess;
  public hasAdminWritePermission: boolean;

  private _destroy$ = new Subject();

  constructor() {
    const data = this.data;

    this.environment = data.environment;
    this.hasSettingsAccess = data.hasSettingsAccess;
    this.hasAdminWritePermission = this._aclService
      .hasPermissionAdmin();
  }

  public close(): void {
    this.menuRef.close();
  }

  public create(): void {
    this.close();

    this.dialog.open(CreateComponent, {
      data: { autofocus: false },
    });
  }

  public switchOrganization(): void {
    this.close();
    this.dialog.open(EnvironmentSwitchComponent, {
      data: {},
    });
  }

  public ngOnDestroy(): void {
    this._destroy$.next(null);
    this._destroy$.complete();
  }

}
